import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Public axios instance
export const api = axios.create({ baseURL: API });

// Admin axios instance (attaches JWT)
export const adminApi = axios.create({ baseURL: API });

const TOKEN_KEY = "novocreste_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

adminApi.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

adminApi.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      clearToken();
      if (window.location.pathname.startsWith("/admin") && window.location.pathname !== "/admin/login") {
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(err);
  }
);

// Resolve media URLs — uploaded files come back as /api/uploads/... (relative)
export const mediaUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  return url;
};

// Resize Unsplash-hosted images on the fly (full-size originals are several MB).
export const imageSized = (url, width = 1600) => {
  const u = mediaUrl(url);
  if (u.includes("images.unsplash.com") && !u.includes("?")) {
    return `${u}?auto=format&fit=crop&w=${width}&q=75`;
  }
  return u;
};
